export const addEventToGTM = ({
  action = '',
  category = '',
  event,
  tag = '',
}) => {
  if (!event) {
    console.error('Event is required')
    return
  }
  let { dataLayer } = window
  dataLayer = dataLayer || []
  dataLayer.push({
    action,
    category,
    event,
    tag,
  })
}
